import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {AppState} from '../../../shared/store/store';
import {Store} from '@ngrx/store';
import {ReportStore} from '../../../shared/store/report/report.store';
import {selectUser} from '../../../shared/store/init/init.selectors';
import {Serializer} from '../../../shared/interfaces/serializer';
import {User} from '../../../shared/interfaces/user';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    ReportStore
  ]
})
export class DashboardComponent implements OnInit {
  public readonly firstname$: Observable<string> = this._store.select(selectUser).pipe(map((user: Serializer<User>): string => user.attributes.firstname));

  constructor(
    private readonly _store:  Store<AppState>,
    private readonly _reportStore: ReportStore
  ) { }

  ngOnInit(): void {
    this._reportStore.init();
  }
}
